"use strict";

import {
     authConstants,
     commonConstants,
     responseCodes,
     lookupTableConstants,
} from "../_constants";

export const INITIAL_LOOKUP_TABLE_STATE = {
     list: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },
     types: [],
     labels: [],
     details: {},
     tableValueList: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },

     tableValueDetails: {},
     csvFileUpload:[],
     status:false,
     searchValue:null,
};

export function lookupTable(state = INITIAL_LOOKUP_TABLE_STATE, action) {
     switch (action.type) {
          /**
           * Customer login
           */

          case lookupTableConstants.LOOKUP_TABLE_LIST_COMPLETE:
               return {
                    ...state,
                    list: {
                         data: [...action.payload.recordsList],
                         totalPageCount: action.payload.totalPageCount,
                         totalRecords: action.payload.totalRecords,
                    },
               };

          case lookupTableConstants.LOOKUP_TABLE_TYPES_COMPLETE:
               return {
                    ...state,
                    types: [...action.payload.recordsList],
               };

          case lookupTableConstants.LOOKUP_TABLE_LABELS_COMPLETE:
               return {
                    ...state,
                    labels: [...action.payload],
               };

          case lookupTableConstants.LOOKUP_TABLE_GET_COMPLETE:
               return {
                    ...state,
                    details: { ...action.payload },
               };

          case lookupTableConstants.LOOKUP_TABLE_VALUE_LIST_COMPLETE:
               return {
                    ...state,
                    tableValueList: {
                         data: [...action.payload.recordsList],
                         totalPageCount: action.payload.totalPageCount,
                         totalRecords: action.payload.totalRecords,
                    },
               };

          case lookupTableConstants.LOOKUP_TABLE_VALUE_GET_COMPLETE:
               return {
                    ...state,
                    tableValueDetails: { ...action.payload },
               };
          case lookupTableConstants.LOOKUP_TABLE_CSV_FILE_UPLOAD_COMPLETE:
               return {
                    ...state,
                    csvFileUpload:action.payload,
                    status:true,
               };
          case lookupTableConstants.LOOKUP_TABLE_CSV_FILE_UPLOAD_CLEAR:
               return {
                    ...state,
                    csvFileUpload:[],
                    status:false,
               }
          case lookupTableConstants.LOOKUP_TABLE_SINGLE_CSV_FILE_UPLOAD_COMPLETE:
               return {
                    ...state,
                    csvFileUpload:action.payload,
                    status:true,
               };
          case lookupTableConstants.LOOKUP_TABLE_SAVE_SEARCH_VALUES:
               return {
                    ...state,
                    searchValue:action.payload,
               };
          case lookupTableConstants.LOOKUP_TABLE_CHANGE_STATUS:
               return {
                    ...state,
                    status:action.payload
               }        
     }

     return state;
}
